import { QuickStartStep } from '../QuickstartContent'

export const verifyTraces: QuickStartStep = {
	title: 'Verify your backend traces are being recorded.',
	content:
		'Visit the [highlight traces portal](http://app.highlight.io/traces) and check that backend traces are coming in.',
}
